import { render, staticRenderFns } from "./DisOrder.vue?vue&type=template&id=4fa44101&scoped=true"
import script from "./DisOrder.vue?vue&type=script&lang=js"
export * from "./DisOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa44101",
  null
  
)

export default component.exports